import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.loyalty;
const getResponseInfo = (state: AppState) => state.loyalty.resAccount;
const getStatusLoyalty = (state: AppState) => state.loyalty.statusLoyalty;
const getResponseLinkWebview = (state: AppState) => state.loyalty.resLinkWebview;

export const getLoyaltyStoreSelector = createSelector(getStore, (data) => data);
export const getLoyaltyAccountSelector = createSelector(getResponseInfo, (info) => info);
export const getStatusLoyaltySelector = createSelector(getStatusLoyalty, (status) => status);
export const getLoyaltyLinkWebviewSelector = createSelector(getResponseLinkWebview, (data) => data);
